import { render, staticRenderFns } from "./ClinicStateBox.vue?vue&type=template&id=5935274a&scoped=true"
import script from "./ClinicStateBox.vue?vue&type=script&lang=js"
export * from "./ClinicStateBox.vue?vue&type=script&lang=js"
import style0 from "./ClinicStateBox.vue?vue&type=style&index=0&id=5935274a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935274a",
  null
  
)

export default component.exports